<div class="m-auto p-4 w-100">
    <header class="d-flex align-items-center">
        <mat-icon (click)="getBackCaseList()">chevron_left</mat-icon>
        <h1>Corrección de archivos del <strong>Caso </strong></h1>
    </header>
    <div class="row mt-4 p-4">
        <div class="col-12 col-lg-6 mb-4 ">
            <mat-card class="card-general flex-fill mb-4">
                <mat-card-title>Comentarios</mat-card-title>
                <mat-card-content>
                    <p>
                        {{rejectedFilesComments}}
                    </p>
                </mat-card-content>
            </mat-card>
        </div>
        <mat-card class="card-general my-3" *ngIf="changesRequiredInSTL">
            <mat-card-title>Archivos STL</mat-card-title>
            <mat-card-content class="d-flex flex-column">
                <!-- STL Form -->
                <form [formGroup]="stlForm">
                    <div class="filetype-grid-container">
                        <div *ngFor="let item of fileSTLArray" class="w-100 h-100 text-center">
                            <ng-container *ngIf="item.name == 'BiteSTL'">
                              <app-drag-and-drop [stlZipOnly]="true" fileTitle="{{item.label}}" [parentForm]="stlForm" [nameControl]="item.name"
                                  [text]="'Sube tu archivo .ZIP o .STL'" [isRequired]="false" isGenericFileType="true"
                                  [accept]="application/octet-stream" (onSelectFile)="fileSelected($event, item, 'stl')"
                                  (onDeleteFile)="deleteFile(item, 'stl')" [fileSelected]="item.fileInfo">
                              </app-drag-and-drop>
                            </ng-container>
                            <ng-container *ngIf="item.name != 'BiteSTL'">
                              <app-drag-and-drop [stlOnly]="true" fileTitle="{{item.label}}" [parentForm]="stlForm" [nameControl]="item.name"
                                  [text]="'Sube tu archivo .STL'" [isRequired]="true" isGenericFileType="true"
                                  [accept]="application/octet-stream" (onSelectFile)="fileSelected($event, item, 'stl')"
                                  (onDeleteFile)="deleteFile(item, 'stl')" [fileSelected]="item.fileInfo">
                              </app-drag-and-drop>
                            </ng-container>
                        </div>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
         <mat-card class="card-general" *ngIf="changesRequiredInImages && isComposite">
            <mat-card-title>Composite</mat-card-title>
            <mat-card-content>
                 <form [formGroup]="compositeSingleForm">
                    <div class="filetype-image-composite-container">
                        <div *ngFor="let item of fileSingleCompositeArray; index as i" class="w-100 h-100">
                            <app-drag-and-drop  fileTitle="{{item.name}}" [parentForm]="compositeSingleForm"
                                [nameControl]="item.name" [text]="'Inserta tu imagen aquí'" [isRequired]="true"
                                [accept]="'image/*'" (onSelectFile)="fileSelected($event, item, 'fileSingleComposite')"
                                (onDeleteFile)="deleteFile(item, 'composite')" [fileSelected]="item.fileInfo">
                            </app-drag-and-drop>
                        </div>
                    </div>
                </form>
            </mat-card-content>
        </mat-card> 

        <mat-card class="card-general my-3" *ngIf="changesRequiredInImages && !isComposite">
            <mat-card-title>Fotografías</mat-card-title>
            <mat-card-content>
              <!-- COMPOSITE FORM -->
              <form [formGroup]="compositeForm">
                <div class="row">
                  <div *ngFor="let item of fileCompositeArray;index as i" class="col-4 h-100">
                    <app-drag-and-drop *ngIf="i!=4" fileTitle="Fotografía {{item.label}} Dental"  [parentForm]="compositeForm" [nameControl]="item.name" [text]="'Inserta tu imagen aquí'" [isRequired]="item.isRequired" [accept]="'image/*'" (onSelectFile)="fileSelected($event, item, 'composite')"
                                       (onDeleteFile)="deleteFile(item, 'composite')" [fileSelected]="item.fileInfo">
                    </app-drag-and-drop>
                  </div>
                </div>
              </form>
            </mat-card-content>
          </mat-card>

        <mat-card class="card-general my-3" *ngIf="changesRequiredInImages">
            <mat-card-title>Radiograf&iacute;as</mat-card-title>
            <mat-card-content>
              <!-- Radiography Form -->
              <form [formGroup]="radiographyForm">
                <div class="filetype-grid-container">
                  <div *ngFor="let item of fileRadiographyArray" class="w-100 h-100">
                    <app-drag-and-drop fileTitle="{{item.label}}" [parentForm]="radiographyForm" [nameControl]="item.name" [text]="'Inserta tu imagen aquí'" [accept]="'image/*'" (onSelectFile)="fileSelected($event, item, 'radiography')"
                                       (onDeleteFile)="deleteFile(item, 'radiography')" [fileSelected]="item.fileInfo">
                    </app-drag-and-drop>
                  </div>
                </div>
              </form>
            </mat-card-content>
          </mat-card>
          <div class="d-flex justify-content-end w-100">
            <div class="col-2">
                <button mat-button class="button secondary-button" (click)="onSendToScapeStatus()">Enviar Corrección</button>
            </div>
          </div>

          
    </div>
</div>

